import React from 'react';
import _ from 'lodash';
import styles from './index.module.scss';

type Data = {
  label: string;
  description?: string;
  value: string;
};
interface IRadio {
  data: Data[];
  handleClick(e: React.ChangeEvent<HTMLInputElement>): void;
}

const RadioButton: React.FC<IRadio> = ({ data, handleClick }) => {
  return (
    <div>
      {!_.isEmpty(data) &&
        data.map((el: Data) => (
          <label key={el.label} className={styles.radio}>
            <input
              type="radio"
              onChange={(e) => handleClick(e)}
              name="r"
              value={el.value}
            />
            <span>{el.label}</span>
            {el.description && <p>{el.description}</p>}
          </label>
        ))}
    </div>
  );
};

export default RadioButton;
